import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { DistributorContractAreasService } from '../services/distributor-contract-areas.service';
import { DistributorContractArea } from '../../models/distributor-contract-area';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmationService } from 'primeng/components/common/api';
import { Response } from '@angular/http';
import { DistributorContract } from '../../models/distributor-contract';
import { environment } from '../../../environments/environment';
import { Postcode } from '../../models/postcode';
import { DistributorContractAreaPostcode } from '../../models/distributor-contract-area-postcode';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import {GroupRightService} from '../../services/group-right.service';
import {GroupRight} from '../../models/group-right';
import {DataTable} from 'primeng/primeng';

@Component({
	selector: 'app-distributor-contract-area-detail',
	templateUrl: './distributor-contract-area-detail.component.html',
	styleUrls: ['./distributor-contract-area-detail.component.css'],
  	encapsulation: ViewEncapsulation.None
})
export class DistributorContractAreaDetailComponent implements OnInit
{
	public contract: DistributorContract;
	public area: DistributorContractArea;
	public isNew: boolean;

	public distributorId: number;
	public contractId: number;

	public groupRight: GroupRight = null;

	public areaHasPostcodeCallback: Function;

	public currentPage: number = 1;
	public lastPaginatorEvent: any;

	@ViewChild('dataTable') dataTable: DataTable;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private breadcrumbService: BreadcrumbService,
		private loadingBar: LoadingBarService,
		private distributorContractAreasService: DistributorContractAreasService,
		private groupRightService: GroupRightService,
	)
	{
	}

	ngOnInit()
	{
		if (this.route.snapshot.data['groupRights'] instanceof Array) {
			this.groupRight = this.groupRightService.getGroupRightForModule('distributor', this.route.snapshot.data['groupRights'])
		}
		this.areaHasPostcodeCallback = this.areaHasPostcode.bind(this);

		this.distributorId = this.route.snapshot.params['distributorId'];
		this.contractId = this.route.snapshot.params['contractId'];

		const contractData: any = this.route.snapshot.data['distributorContract'];

		if (contractData instanceof Object && !(contractData instanceof Response))
		{
			// The contract was received.
			this.contract = contractData;
			this.breadcrumbService.addBreadcrumbTranslation('Verspreider Bewerken', this.contract.distributor.name);
		}
		else if (contractData instanceof Response)
		{
			// We got a unhandled exception, let's show a message.
			this.messageService.add({
				severity: 'error',
				summary: 'Fout',
				detail: 'Er is een fout opgetreden tijdens het ophalen van het contract.'
			});
		}

		const areaData: any = this.route.snapshot.data['distributorContractArea'];

		if (areaData instanceof Object && !(areaData instanceof Response))
		{
			// DistributorContractArea was received.
			this.area = areaData;

			this.breadcrumbService.addBreadcrumbTranslation(this.route.snapshot.data['breadcrumb'], this.area.delivery_street + ' ' + this.area.delivery_house_number);
			this.isNew = false;
		}
		else
		{
			// We are creating a new DistributorContractArea, or something went wrong.
			this.area = new DistributorContractArea();
			this.area.distributorContract = new DistributorContract();
			this.area.distributorContract.id = this.contractId;
			this.isNew = true;

			if (areaData instanceof Response)
			{
				// We got a unhandled exception, let's show a message.
				this.messageService.add({
					severity: 'error',
					summary: 'Fout',
					detail: 'Er is een fout opgetreden tijdens het ophalen van het gebied.'
				});
			}
		}

		if (typeof this.area.distributorContractAreaPostcodes === 'undefined')
		{
			this.area.distributorContractAreaPostcodes = [];
		}

		for( var i=0; i<this.area.distributorContractAreaPostcodes.length; i++){
			var areaPostalcode = this.area.distributorContractAreaPostcodes[i];
			areaPostalcode.saveable = this.validateSaveableAreaPostalCode(areaPostalcode);
			areaPostalcode.valid = this.validateAreaPostalCode(areaPostalcode);
		}
	}

	public hasUserAccess(action: string)
	{
		return this.groupRight && this.groupRight[action];
	}

	public goBack()
	{
		this.router.navigate(['/verspreiders/' + this.distributorId + '/contracten/' + this.contractId]);
	}

	public validateSaveableAreaPostalCode(areaPostalcode: DistributorContractAreaPostcode) {
		let givenIndex = this.area.distributorContractAreaPostcodes.indexOf(areaPostalcode);
		var walkdayMatches = this.area.distributorContractAreaPostcodes.filter( function(postalCode, index){
			if(index != givenIndex && areaPostalcode.postcode.id == postalCode.postcode.id
			&& postalCode.walkday == areaPostalcode.walkday){ return true; 	}
			return false;
		});
		return (areaPostalcode.net_amount != null && areaPostalcode.gross_amount != null &&
			areaPostalcode.total_amount != null && areaPostalcode.walkday != null && walkdayMatches.length == 0);
	}

	public validateAreaPostalCode(areaPostalcode: DistributorContractAreaPostcode) {
		if(areaPostalcode.gross_amount > areaPostalcode.total_amount){ return false; }
		if(areaPostalcode.net_amount > areaPostalcode.gross_amount){ return false; }
		if(areaPostalcode.walkday == null){ return false; }
		return true;
	}

	public validatePostcodeInput(areaPostalcode: DistributorContractAreaPostcode){
		areaPostalcode.saveable = this.validateSaveableAreaPostalCode(areaPostalcode);
		areaPostalcode.valid = this.validateAreaPostalCode(areaPostalcode);
	}

	public validateRow(areaPostalcode) {
		if(!areaPostalcode.saveable){ return "invalid fail"; }
		return areaPostalcode.valid ? "valid" : "invalid warn";
	}

	public saveArea()
	{
		var valid = true;
		for(let areaPostcode of this.area.distributorContractAreaPostcodes) {
			if(!this.validateSaveableAreaPostalCode(areaPostcode)){ valid = false; }
		}

		if(!valid) {
			this.messageService.add({
				severity: 'warning',
				summary: 'Validatiefout',
				detail: 'Niet alle postcodes zijn juist ingevoerd.'
			});
			return;
		}

		let promise: Promise<DistributorContractArea>;
		this.loadingBar.start();
		if (this.isNew)
		{
			promise = this.distributorContractAreasService.storeDistributorContractArea(this.area);
		}
		else
		{
			promise = this.distributorContractAreasService.updateDistributorContractArea(this.area);
		}

		promise.then((data) =>
		{
			this.loadingBar.complete();
			if (data instanceof Response)
			{
				if (data.status === 422)
				{
					const shownMessages: Array<string> = [];
					const message: Object = data.json().message;

					Object.keys(message).forEach((fieldName) =>
					{
						message[fieldName].forEach((message) =>
						{
							if (shownMessages.indexOf(message) === -1)
							{
								shownMessages.push(message);

								this.messageService.add({
									severity: 'warning',
									summary: 'Validatiefout',
									detail: environment.validation.distributor_contract_area[message]
								});
							}
						});
					});
				}
				else
				{
					this.messageService.add({
						severity: 'error',
						summary: 'Gebied niet opgeslagen',
						detail: 'Er is een fout opgetreden tijdens het opslaan van het gebied.'
					});
				}
			}
			else
			{
				this.messageService.add({
					severity: 'success',
					summary: 'Gebied opgeslagen',
					detail: 'Het gebied is opgeslagen.'
				});

				this.router.navigate(['/verspreiders/' + this.distributorId + '/contracten/' + this.contractId + '/gebieden/' + data.id]);
			}
		});
	}

	public removeArea()
	{
		this.confirmationService.confirm({
			message: 'Weet u zeker dat u dit gebied wilt verwijderen?',
			header: 'Gebied verwijderen?',
			icon: 'fa fa-trash',
			accept: () =>
			{
				this.distributorContractAreasService.removeDistributorContractArea(this.area.id)
					.then((data) =>
					{
						this.messageService.add({
							severity: 'success',
							summary: 'Gebied verwijderd',
							detail: 'Het gebied is verwijderd.'
						});

						this.router.navigate(['/verspreiders/' + this.distributorId + '/contracten/' + this.contractId]);
					})
					.catch((data) =>
					{
						this.messageService.add({
							severity: 'error',
							summary: 'Gebied niet verwijderd',
							detail: 'Het gebied kon niet worden verwijderd.'
						});
					});
			}
		});
	}

	public addPostcode(postcode: Postcode)
	{
		const areaPostcode: DistributorContractAreaPostcode = new DistributorContractAreaPostcode();
		areaPostcode.postcode = postcode;
		areaPostcode.walkday = "Maandag";
		areaPostcode.gross_amount = postcode.gross_amount;
		areaPostcode.net_amount = postcode.net_amount;
		areaPostcode.total_amount = postcode.gross_amount;
		this.area.distributorContractAreaPostcodes.push(areaPostcode);

		this.saveArea();
	}

	public removePostcode(areaPostcode: DistributorContractAreaPostcode)
	{
		this.messageService.add({
			severity: 'warning',
			summary: 'Postcode verwijderd',
			detail: environment.validation.distributor_contract_area['removed_postalcode']
		});

		this.area.distributorContractAreaPostcodes.splice(this.area.distributorContractAreaPostcodes.indexOf(areaPostcode), 1);
		// Restore the paginator state
		if (this.lastPaginatorEvent) {
			//We need to put the state restoration inside a timeout function, so we can essentially defer the execution of that code until the next available cycle in the JavaScript event loop.
			//So UI can update first, this will not work outside setTimeout.
			setTimeout(() => {
				this.dataTable.onPageChange(this.lastPaginatorEvent);
			}, 0);
		}

		this.saveArea();
	}

	public areaHasPostcode(postcode: Postcode): boolean
	{
		let found = false;

		this.area.distributorContractAreaPostcodes.forEach((areaPostcode: DistributorContractAreaPostcode) =>
		{
			if (areaPostcode.postcode.id === postcode.id)
			{
				found = true;
			}
		});

		if (!found && typeof this.contract.distributorContractAreas !== 'undefined')
		{
			this.contract.distributorContractAreas.forEach((area: DistributorContractArea) =>
			{
				if (area.id !== this.area.id && typeof area.distributorContractAreaPostcodes !== 'undefined')
				{
					area.distributorContractAreaPostcodes.forEach((areaPostcode: DistributorContractAreaPostcode) =>
					{
						if (areaPostcode.postcode.id === postcode.id)
						{
							found = true;
						}
					});
				}
			});
		}

		return found;
	}

	public onPageChange(event) {
		this.currentPage = event.first / event.rows
		this.lastPaginatorEvent = event
	}

	public compareFn(a, b) {
		if(a != undefined && b != undefined && a != null && b != null)
		{
			return a.id == b.id;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/distributor-contract-area-detail/distributor-contract-area-detail.component.ts